<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_gift_card_data") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <v-row>
            <v-col cols="12">
              <base-image-upload-input
                col="12"
                identifier="salon_logo"
                :preSelectedImage="data.image.path"
                :placeholder="$t('PLACEHOLDERS.design')"
                @selectImage="selectImage"
                disabled
              />
            </v-col>
          </v-row>

          <!-- ********** End::  slider Data ********** -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.card_name_ar')"
            v-model.trim="data.card_name_ar"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.card_name_en')"
            v-model.trim="data.card_name_en"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- start card_price tel -->

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.card_price')"
            v-model="data.card_price"
            disabled
          />
          <!-- end card_price tel -->

          <!-- Start:: discount_percentage Input -->
          <base-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.discount_percentage') + '%'"
            v-model.trim="data.discount_percentage"
            type="number"
            disabled
          />
          <!-- End:: discount_percentage Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateCity",

  components: {
    UploadsPhotos,
    ChangableMapComponent,
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      EnRegex: /[\u0600-\u06FF]/,

      // Start:: Data Collection To Send
      data: {
        image: {
          path: "",
          file: "",
        },
        salon_image: {
          path: "",
          file: "",
        },
        card_name_ar: null,
        card_name_en: null,
        card_enum: null,
        card_price: null,
        discount_percentage: null,
        active: 0,
      },

      additionalImages: [],
      imgUrls: [],
      main_sections: [],
      sub_sections: [],
      card_enum: [],

      imageId: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),
  },

  methods: {
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // start show data
    async showData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `discount-cards-types/${this.$route.params.id}`,
        });

        this.data.card_name_ar = res.data.data?.discount_card_type.name_ar;
        this.data.card_name_en = res.data.data?.discount_card_type.name_en;

        this.data.image.path = res.data.data?.discount_card_type.design;

        this.data.discount_percentage =
          res.data.data?.discount_card_type.discount_percentage.slice(0, 2);

        this.data.card_price = res.data.data?.discount_card_type.price;

        this.data.active = +res.data.data?.discount_card_type.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    this.showData();
  },
};
</script>
